import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, SELECT_ALL_COMMAND } from 'lexical';
import { useEffect } from 'react';

import { HtmlPluginProps } from './HtmlPlugin.types';

export const HtmlPlugin = ({ value, innerHtml, setInnerHtml }: HtmlPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        setInnerHtml(
          $generateHtmlFromNodes(editor, null)
            .replace(/width: 75px; ?/g, '')
            .replace(/white-space: pre-wrap; ?/g, '')
            .replace(/border: 1px solid black; ?/g, '')
            .replace(/background-color: rgb\(242, 243, 245\); ?/g, '')
            .replace(/vertical-align: top; ?/g, '')
            .replace(/text-align: start; ?/g, '')
            .replace(/ style=""/g, '')
            .replace(/ dir="ltr"/g, '')
            .replace(/ class="[\w\s]+"/g, '')
            .replace(/<colgroup>(<col>)+<\/colgroup>/g, '')
        );
      });
    });
  }, [editor, setInnerHtml]);

  useEffect(() => {
    if (value !== innerHtml) {
      editor.update(() => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(value, 'text/html');
        const nodes = $generateNodesFromDOM(editor, dom);
        editor.dispatchCommand(SELECT_ALL_COMMAND, new KeyboardEvent('keydown'));
        const selection = $getSelection();
        selection?.insertNodes(nodes);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor, value]);

  return null;
};
